import React from 'react';
import { CheckIcon, MailIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { includedToday, urgency } from '../data/content';
export function Offer() {
  return <section id="comprar" className="scroll-mt-24 bg-paper-soft px-5 py-20 sm:py-28 lg:px-8" aria-labelledby="oferta" data-id="element-126" data-mp="1mmqwo0hxrdn4">
      <div className="mx-auto grid max-w-6xl items-center gap-14 lg:grid-cols-[1fr_0.95fr] lg:gap-20" data-id="element-127" data-mp="tyblxq5u7hhl">
        <div data-id="element-128" data-mp="p0a2h44i1g5l">
          <Reveal data-id="element-129" data-mp="p0tn4sljainb">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.28em] text-grass" data-id="element-130" data-mp="p1bepbx948ow">
              ¿Cuánto vale tu tranquilidad?
            </p>
            <h2 id="oferta" className="display mt-4 text-4xl text-ink sm:text-5xl lg:text-6xl" data-id="element-131" data-mp="yy7pjoamh6wm">
              Un curso por cada tema te costaría más de $350.000
            </h2>
            <p className="mt-6 max-w-readable text-lg leading-relaxed text-ink-soft" data-id="element-132" data-mp="2adwcwgrsg7xy">
              Y si perdés 8 horas por semana planificando a mano, estás perdiendo
              plata y tiempo con tu familia. Hoy no vas a pagar eso: queremos que el
              fútbol de barrio suba de nivel.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.06} data-id="element-133" data-mp="zgafcjt205sp">
          <div className="rounded-xl border border-paper-line bg-paper p-7 shadow-xl sm:p-9" data-id="element-134" data-mp="13jqatcte003t">
            <h3 className="display text-2xl text-ink sm:text-3xl" data-id="element-135" data-mp="6tzgbdl3icy0">
              ¿Qué te vas a llevar hoy?
            </h3>

            <ul className="mt-6 space-y-3" data-id="element-136" data-mp="bs0x1rv1u06b">
              {includedToday.map(item => <li key={item} className="flex items-start gap-3 text-[15px] font-medium text-ink sm:text-base" data-id="element-137" data-mp="fu5qaphl4usf">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grass" aria-hidden="true" data-id="element-138" data-mp="3k8m0yu8tq32k" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-8 border-t border-paper-line pt-7" data-id="element-139" data-mp="veyyqji1b0y8">
              <p className="text-sm font-bold uppercase tracking-wide text-ink-dim" data-id="element-140" data-mp="qgnrmgj4j4jp">
                Todo el megapack
              </p>
              <div className="mt-2 flex items-end gap-3" data-id="element-141" data-mp="154ijxvt7z6w9">
                <span className="display text-6xl text-grass sm:text-7xl" data-id="element-142" data-mp="106h1nd3mbblu">
                  $24.999
                </span>
              </div>
              <p className="mt-2 text-sm text-ink-dim" data-id="element-143" data-mp="chxrst4x6qrn">
                Pago único. Acceso de por vida y actualizaciones gratis.
              </p>
            </div>

            <CtaButton size="lg" className="mt-8 w-full" data-id="element-144" data-mp="lhb4rvs95xh4">
              Pagar con Mercado Pago
            </CtaButton>

            <div className="mt-6 space-y-2 text-[13px] text-ink-soft" data-id="element-145" data-mp="hfpw6mmr45cq">
              <p className="flex items-center gap-2" data-id="element-146" data-mp="1wwpz0rt2ub8j">
                <ShieldCheckIcon className="h-4 w-4 shrink-0 text-grass" aria-hidden="true" data-id="element-147" data-mp="1wv55n5ii0yc9" />
                Pagá con Mercado Pago: seguro, rápido y confiable.
              </p>
              <p className="flex items-center gap-2" data-id="element-148" data-mp="20h08jeupl3d0">
                <MailIcon className="h-4 w-4 shrink-0 text-grass" aria-hidden="true" data-id="element-149" data-mp="25erwxyw5a7cg" />
                Acceso inmediato vía mail, apenas se acredita el pago.
              </p>
              <p className="flex items-center gap-2" data-id="element-150" data-mp="1vf12tybhxucw">
                <ZapIcon className="h-4 w-4 shrink-0 text-grass" aria-hidden="true" data-id="element-151" data-mp="1vfsy1816lq2n" />
                Quedan {urgency.spotsLeft} de {urgency.spotsTotal} cupos con bonos
                incluidos.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}